'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const TextIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="TextIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        id="Text-Format-1--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Text Format 1 Streamline Icon: https://streamlinehq.com</desc>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M15.7 12.05c0 -2.10001 1.7 -3.8 3.8 -3.8 2.1 0 3.8 1.69999 3.8 3.8v7.8"
          strokeWidth="1"
        ></path>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M23.2 13.0498c-1.1 0.9 -2.5 1.4 -3.9 1.4h-0.5c-1.7 0 -3.1 1.2 -3.1 2.7 0 1.5 1.4 2.7 3.1 2.7 0 0 3.1 0 4.4 -2.7"
          strokeWidth="1"
        ></path>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M0.927132 19.8498 5.38694 6.47031c0.22864 -0.68589 0.87052 -1.14853 1.59351 -1.14853v0c0.723 0 1.36488 0.46264 1.59351 1.14853L13.0338 19.8498M2.54135 15.0071h8.87825"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

TextIcon.propTypes = {
  sx: PropTypes.object
}
